import { render, staticRenderFns } from "./ImageSelectionModal.vue?vue&type=template&id=3ce5c4d2"
import script from "./ImageSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSelectionModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports